<template>
  <div class="custom-title df-c">
    <img src="@/assets/images/bigscreenSales/title_icon.png" width="32px" height="32px" />
    <div class="month" v-if="month">{{month}}</div>
    <div class="title">{{title}}</div>
  </div>
</template>

<script>
export default {
  name: 'CustomTitle',
  props: {
    title: {
      type: String,
      default: '标题'
    },
    month: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  components: {},
  watch: {},
  mounted () {},
  methods: {}
}
</script>

<style scoped lang="less">
.custom-title {
  height: 34px;
  .month {
    margin-left: 8px;
    height: 31px;
    font-family: 'D-DIN';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 26px;
    display: flex;
    align-items: center;
    letter-spacing: 1.09394px;
    background: linear-gradient(0deg, #ffffff, #ffffff),
      linear-gradient(180deg, #2dcdff 37.5%, #2ffff4 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    border-bottom: 1px solid #ffffff;
  }
  .title {
    margin-left: 8px;
    height: 34px;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 34px;
    display: flex;
    align-items: center;
    letter-spacing: 1.09394px;
    background: linear-gradient(180deg, #2dcdff 37.5%, #2ffff4 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomTitle.vue